// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import EmployeeClient from '@/api/employee/employee-client';
const employeeClient = new EmployeeClient();
export default {
    createEmployee: async function (context, payload) {
        var result = await employeeClient.postAsync({
            url: `${employeeClient.url}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    updateEmployee: async function (context, payload) {
        var result = await employeeClient.putAsync({
            url: `${employeeClient.url}/${payload.id}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    deleteEmployee: async function (context, payload) {
        var result = await employeeClient.deleteAsync({
            url: `${employeeClient.url}/${payload.id}/delete`,
            queries: payload,
        }, true);
        return result;
    },


    getEmployee: async function (context, payload) {
        var result = await employeeClient.getAsync({
            url: `${employeeClient.url}/${payload.id}/detail`,
            data: payload
        }, true);
        if (result && result.data) {
            return result.data;
        }
        return null;
    },

    getEmployees: async function (context, payload) {
        var result = await employeeClient.getAsync({
            url: `${employeeClient.url}/search`,
            queries: payload
        }, true);
        if (result && result.data) {
            context.commit('updateTotalPage', result.data);
            return result.data;
        }
        return null;
    },

    getEmployeeList: async function (context, payload) {
        var result = await employeeClient.getAsync({
            url: `${employeeClient.url}/search`,
            queries: payload
        }, true);
        if (result && result.data) {
            context.commit('updateEmployees', result.data.rows);
            return result.data.rows;
        }
        return [];
    },
}